var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:#fff;}.a{stroke:#707070;stroke-width:0.1px;}.b{clip-path:url(#a);}.c,.g{fill:none;}.c,.d{stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.e{fill:#e2e8f3;}.f{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-2773 -4038)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(2773 4038)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.315 1.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2760.241-4037.4s-.113,6.279-.128,9.876-.352,7.119,5.36,9.941,1.584,13.408-5.68,9.269-12.185,2.6-12.47,6.528,0,10.063,0,10.063"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2754.8-4037.4v13.117s8.345-4.611,14.713,2.581c3.076,3.474,4.616,11.457,1.757,17.293-2.818,5.758-8.566,8.575-15.3,8.767s-10.3-7.411-11.29-7.937a1.631,1.631,0,0,0-2.524.875c-.375,2.874-.2,6.147-.207,11.5",
    transform: "translate(-0.301)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-2747.465 -4021.88)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 8.99,
    cy: 8.99,
    r: 8.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 8.99,
    cy: 8.99,
    r: 8.24
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-2729.876-4004.979l6.862,6.972",
    transform: "translate(-2.33 -1.74)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-2734.722-4018.069a7.7,7.7,0,0,1,1.237,5.76c-.58,3.481-3.324,6.035-5.288,5.5,2.774,1.734,7.584-2.282,7.181-6.473S-2734.722-4018.069-2734.722-4018.069Z",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality3);
export default __webpack_public_path__ + "static/media/speciality3.f625165538600f2caffb9ebf5aad66af.svg";
export { ForwardRef as ReactComponent };